import { render, staticRenderFns } from "./exhibitions.vue?vue&type=template&id=522d9426&scoped=true&"
import script from "./exhibitions.vue?vue&type=script&lang=js&"
export * from "./exhibitions.vue?vue&type=script&lang=js&"
import style1 from "./exhibitions.vue?vue&type=style&index=1&id=522d9426&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522d9426",
  null
  
)

export default component.exports